var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.548,
    height: 37.82,
    viewBox: "0 0 46.548 37.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M46.548,52.477a19.9,19.9,0,0,1-5.5,1.507,9.489,9.489,0,0,0,4.2-5.274A19.071,19.071,0,0,1,39.2,51.02a9.542,9.542,0,0,0-16.507,6.525,9.826,9.826,0,0,0,.221,2.176A27.011,27.011,0,0,1,3.241,49.74,9.545,9.545,0,0,0,6.173,62.494a9.424,9.424,0,0,1-4.311-1.175v.1A9.587,9.587,0,0,0,9.507,70.8a9.524,9.524,0,0,1-2.5.314A8.437,8.437,0,0,1,5.2,70.951,9.634,9.634,0,0,0,14.116,77.6a19.174,19.174,0,0,1-11.832,4.07A17.874,17.874,0,0,1,0,81.538,26.865,26.865,0,0,0,14.639,85.82C32.2,85.82,41.8,71.274,41.8,58.665c0-.422-.015-.829-.035-1.234A19.037,19.037,0,0,0,46.548,52.477Z",
    transform: "translate(0 -48)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c2c8050fc9aa3b1379e081e1646e2b2a.svg";
export { ForwardRef as ReactComponent };